import React, { useState, useEffect } from 'react';
import { CardColumn } from './cardColumn';
import * as R from 'ramda';

export const Card = ({ cardType, icon, branch, isMain, globalPayload, setGlobalPayload}) => {
    const [number, setNumber] = useState(!R.isNil(globalPayload.payload) ? globalPayload.payload.accounts.filter(a => a.accountType === cardType.accountType).length : 0);

    const [arr, setArr] = useState([]);
    useEffect(() => {
        if(number === 0){
            setArr([]);
        }
        else if(number > 0 && number < 4){
            setArr([[...Array(number).keys()]]);
        }else{
            let a = [[1, 2, 3]];
            let fullLines = Math.trunc((number - 3)/4);
            let num = 3;

            let i = 0;
            for(; i < fullLines; i++){
                a[i + 1] = [];
                for(let j = 0; j < 4; j++, num++){
                    a[i + 1][j] = num;
                }
            }

            let casesForLastLine = (number - 3)%4;
            a[i + 1] = [];
            for(let j = 0; j < casesForLastLine; j++, num++){
                a[i + 1][j] = num;
            }
            
            setArr(a);
            
        }
    }, [number]);
    return (
        <div className={"card rounded border-common flex-lg-column picker-card" + (number > 0 && number < 3 ? ' active shadow grid-column-' + (number + 1) : '') + (number > 2 ? ' active shadow grid-column-4' : '')}>
            <div className="flex-row">
                <div className="card-header px-1 py-3 flex-column text-center">
                    <img className="img-fluid mx-auto my-2 h-6 py-1" src={icon} alt={cardType.name} />
                    <h6 className="h6 text-uppercase font-weight-bolder container-tight mx-auto pb-xs word-fluid">{cardType.name}</h6>
                    <div className="grid grid-2 w-75 mx-auto mt-auto">
                        <label htmlFor={"Nombre"+cardType.name} className="label text-right my-auto h6 font-weight-bold">Nombre</label>
                        <input type="number" className="form-control" id={"Nombre"+cardType.name+(!R.isNil(branch.id) ? branch.id: '')} placeholder="0" value={number} onChange={(e) => {
                            e.preventDefault();
                            let val = e.target.value === "" ? 0 : parseInt(e.target.value);
                            setNumber(val < 0 ? 0 : val > 20 ? 20 : val);
                        }} />
                    </div>
                </div>
                {
                    R.isNil(arr[0]) ?
                        ''
                    :
                        arr[0].map((n, index) => {
                                return (
                                    <CardColumn key={index} n={n} cardType={cardType} branch={branch} isMain={isMain} globalPayload={globalPayload} setGlobalPayload={setGlobalPayload}/>
                                )
                            })
                }
            </div>
            {
                R.isNil(arr[0]) ?
                    ''
                :
                    Object.values(arr).map((line, colIndex) => {
                        if(colIndex === 0)
                            return ''
                        else
                            return(<div className="flex-row">
                                {
                                    line.map((n, index) => {
                                        return (
                                            <CardColumn key={index} n={n} cardType={cardType} branch={branch} isMain={isMain} globalPayload={globalPayload} setGlobalPayload={setGlobalPayload} />
                                        )
                                    })
                                }
                            </div>)
                    })

            }
        </div>
    );
}